'use es6';

import { createSelector } from 'reselect';
import * as RequestKey from '../constants/RequestKey';
const getRequestStates = state => state.requestStates;
export const getAppIntegrationsRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.APP_INTEGRATIONS]);
export const getAdminRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.ADMINS]);
export const getPortalScopeRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.HUBS]);